import * as styles from "./KbdGroup.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { KbdGroupProps } from "./Kbd.types";

export function KbdGroup({ className, ...props }: KbdGroupProps): JSX.Element {
  return (
    <kbd
      data-slot="kbd-group"
      className={clsx(styles.group, className)}
      {...props}
    />
  );
}
